import scrollViewport from '../utils/scroll-viewport';

var caseLength = window.caseLenght || 0;
var one = {};
scrollViewport('.screen', function($screen) {
  $screen.addClass('active').removeClass('disabled-animated');
}, {
  delayDistance: 200,
  onLeave: function($screen) {
    $screen.removeClass('active');
  }
});



// WEBPACK FOOTER //
// ./src/js/joinUs.js